import ApplicationMetadataCard from './ApplicationMetadataCard.component';

export default ApplicationMetadataCard;